<script lang="ts">
  import { fade } from 'svelte/transition'
  import Form from './new/Form.svelte'
  import keywordsStore, { responderActive, responderMode } from '@/stores/keywords.svelte'

  let {
    initialKeywords = [],
    shortCode = ''
  } = $props()

  let keywords = $state(JSON.parse(initialKeywords))
  let allGroupsVisibility = $state({})


  function autoResponderStatus(keyword) {
    if (!isAutoresponder(keyword)) return
    return responderActive(keyword) ? 'On' : 'Off'
  }

  function responderLabel(keyword) {
    if (!isAutoresponder(keyword)) return keyword.keyword_type
    return responderMode(keyword) === 'ai' ? 'AI-responder' : 'Auto-responder'
  }

  function confirmDelete(keyword) {
    swal({
        title: "Are you sure?",
        type: "warning",
        showCancelButton: true
      },
      confirmed => {
        if (confirmed) {
          keywordsStore.delete(keyword)
            .then(response => {
              let i = keywords.indexOf(keyword)
              if (i > -1) {
                keywords.splice(i, 1)
              }
            })
        }
      })
  }

  function isAutoresponder(keyword) {
    return keyword.keyword_type == 'Autoresponder'
  }

  function showingAllGroups(id) {
    return allGroupsVisibility[id]
  }

  function toggleAllGroups(id) {
    allGroupsVisibility[id] = !allGroupsVisibility[id]
  }
</script>

<div class="KeywordsIndex">
  <Form {shortCode} />

  <table class="separated-rows">
    <thead>
    <tr>
      <th>Keyword</th>
      <th class="shrink">
        Type
      </th>
      <th style="width: 50%">Contacts</th>
      <th class="shrink">Manage</th>
    </tr>
    </thead>

    <!-- Each keyword is its own card: the usual row, plus a strip saying what to tell contacts -->
    {#each keywords as keyword (keyword.to_param)}
    <tbody class="keyword-card" transition:fade>
      <tr class="keyword-card__gap" aria-hidden="true"><td colspan="4"></td></tr>
      <tr class="keyword-card__main">
        <td>
          <a href="/keywords/{keyword.to_param}/edit">
            {keyword.keyword}
          </a>
        </td>
        <td>
          {responderLabel(keyword)}
          <span class:d-none={!isAutoresponder(keyword)}
                class="autoresponder-status"
                data-status={autoResponderStatus(keyword)}></span>
        </td>

        <td>
          {#if keyword.retain_new_contacts}
            <div class="flex-row">
              <div class="cell-0">
                <span class="icon icon--contacts-saved"></span>
              </div>
              <div class="cell-1">

                <div class="group-labels" class:active={showingAllGroups(keyword.to_param)}>
                  Contacts are saved to

                  {#if !keyword.add_to_groups.length}
                    <div class="label label--group-name">Account</div>
                  {:else if keyword.add_to_groups.length === 1}
                    <div class="label label--group-name">{keyword.add_to_groups[0].group.name}</div>
                  {:else}
                    {#each keyword.add_to_groups as step (step.id)}
                      <div class="label label--group-name">
                        {step.group.name}
                      </div>
                    {/each}
                    <button type="button" class="group-labels-show-more btn-link"
                            onclick={() => toggleAllGroups(keyword.to_param)}>
                      Show {keyword.add_to_groups.length - 1} more
                    </button>
                  {/if}

                </div>
              </div>
            </div>
          {:else}
            <span class="icon icon--contacts-not-saved"></span>
            Contacts are <strong>not</strong> being saved
          {/if}
        </td>

        <td class="actions">
          <a href="/keywords/{keyword.to_param}/edit">
            Edit
            <span class="icon icon--keywords-edit"></span>
          </a>
          <button type="button" onclick={() => confirmDelete(keyword)} class="btn btn-link">
            Delete
            <span class="icon icon--keywords-delete"></span>
          </button>
        </td>
      </tr>
      <tr class="keyword-card__share">
        <td colspan="4">
          Tell contacts: Text <strong>{keyword.keyword}</strong> to <strong>{shortCode}</strong>
        </td>
      </tr>
    </tbody>
    {/each}
  </table>

</div>

<style lang="scss">
  .btn-link {
    color: rgb(94, 186, 50);
    font-size: 1em;
    margin: 0;
  }

  table.separated-rows th,
  table.separated-rows td {
    padding: .5em;
    vertical-align: middle;
  }

  table.separated-rows th:first-child,
  table.separated-rows td:first-child {
    padding-left: 1em;
  }

  /* Cards are spaced with a gap row instead of border-spacing, so the
     share strip can sit flush under its keyword's row */
  table.separated-rows {
    border-spacing: 0;
    margin-top: 0;
  }

  table.separated-rows .keyword-card__gap td {
    border: none;
    height: 1.5em;
    padding: 0;
  }

  .keyword-card__main td {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-bottom-color: rgb(236, 237, 238);
  }

  .keyword-card__share td {
    background: rgb(249, 249, 249);
    border-top: none;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    color: rgb(107, 108, 113);
    font-size: 1.05em;
    padding: 0.6em 1em;
    white-space: normal;
  }

  .keyword-card__share strong {
    color: rgb(83, 160, 50);
    font-weight: 600;
  }

  /* The shared per-row hover shadow would split the card in two (and outline the gap row) */
  .keyword-card tr:hover {
    box-shadow: none;
  }

  .keyword-card:hover .keyword-card__main td,
  .keyword-card:hover .keyword-card__share td {
    border-color: rgba(94, 186, 50, 0.7);
  }

  .keyword-card:hover .keyword-card__main td {
    border-bottom-color: rgb(236, 237, 238);
  }
</style>
